// tslint:disable:max-line-length

import React from 'react';

export const ActionCloseThin = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <polygon points="15.5,1.9 14.1,0.5 8,6.6 1.9,0.5 0.5,1.9 6.6,8 0.5,14.1 1.9,15.5 8,9.4 14.1,15.5 15.5,14.1 9.4,8" />
    </svg>
  );
};
